"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// light polyfill for Object.assign

exports.default = function (base) {
  var extend = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
  return Object.keys(extend).reduce(function (out, key) {
    out[key] = extend[key];
    return out;
  }, base);
};

module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./~/inline-style-prefixer/lib/utils/assign.js
 ** module id = 21
 ** module chunks = 0
 **/